import { useAppSelector } from 'hooks/useAppSelector';
import type { AnalyticCategoryActions } from 'models';
import { useCallback } from 'react';
import type { Category } from 'shared/middlewares/analytics/logger';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { getLifecyclePortalUrl } from 'state/user/user.selector';

export const useOpenLifecycleFromProductId = (
  category: Category = 'Secondary market',
  action: AnalyticCategoryActions[Category] = 'Open Lifecycle portfolio',
) => {
  const lifecyclePortalUrl = useAppSelector(getLifecyclePortalUrl);

  return useCallback(
    (productKey: string) => {
      if (lifecyclePortalUrl !== undefined) {
        const url = lifecyclePortalUrl + `/portfolio/product-key/${productKey}?tab=details`;
        openLifecycleWithUrl(url, category, action);
      }
    },
    [lifecyclePortalUrl, category, action],
  );
};

export const openLifecycleWithUrl = (
  url: string | null | undefined,
  category: Category = 'Secondary market',
  action: AnalyticCategoryActions[Category] = 'Open Lifecycle portfolio',
) => {
  if (url !== undefined && url !== null) {
    logAnalytics.trackEvent(category, action);
    window.open(url, '_blank');
  }
};
